import { ActionType, getType } from 'typesafe-actions';

import * as config from '../../actionCreators/config';

export default function (
  state: Brand[] | null = null,
  action: ActionType<typeof config>,
): Brand[] | null {
  switch (action.type) {
    case getType(config.setBrands): {
      const { value } = action.payload;

      if (!value) {
        return null;
      }

      return value.length ? value : null;
    }
    default:
      return state;
  }
}
